import type { IRequestOpts, IResultstash, JsonQuery } from "@mne-core/api";
import { QueryController, createGetRequestOpts, createUrl, fetchJsonQuery } from "@mne-core/api";

export interface IRequestOpenIdProviderLinkCriteria {
  email: string;
}

export const createRequest = ({ ...restCriteria }: IRequestOpenIdProviderLinkCriteria, opts: IRequestOpts) => {
  const { apiUrl } = opts;
  const uri = createUrl(apiUrl, ["authentication", "v1", "openid", "provider", "userlink"], restCriteria).toString();
  return new Request(uri, createGetRequestOpts(opts));
};
export async function requestOpenIdProviderLink(
  criteria: IRequestOpenIdProviderLinkCriteria,
  opts: IRequestOpts,
  // eslint-disable-next-line @typescript-eslint/no-empty-object-type
): Promise<JsonQuery<IResultstash<{}>>> {
  // eslint-disable-next-line @typescript-eslint/no-empty-object-type
  return await fetchJsonQuery<IResultstash<{}>>(createRequest(criteria, opts), {
    ctrl: opts.ctrl || new QueryController(),
  });
}
